import { useParams } from 'react-router-dom';
import { Box, makeStyles, Typography } from '@material-ui/core';

import CanvaKoin from '../models/CanvaKoin';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(2),
    borderStyle: 'none',
    height: '80%',
  },
  text: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: 40,
  },
}));
function LoadingSede() {
  const params = useParams();
  const classes = useStyles();
  const { theme } = params;
  return (
    <Box className={classes.container}>
      <CanvaKoin widthValue={300} heightValue={300} />
      <Typography className={classes.text}>{`De camino a ${theme}...`}</Typography>
    </Box>
  );
}

export default LoadingSede;
